import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { User } from '../Models/Commonmodule/user';
import { Role } from '../Models/Commonmodule/role';
import { Form } from '../Models/Commonmodule/form';
import { Roledetails } from '../Models/Commonmodule/roledetails';

import { Homepage } from '../Models/homepage';
import { clientMaster } from '../Models/BasicForms/clientMaster';
import { project } from '../Models/BasicForms/project';
import { moduleMaster } from '../Models/BasicForms/moduleMaster';
import { featureMaster } from '../Models/BasicForms/featureMaster';
import { categoryMaster } from '../Models/BasicForms/categoryMaster';
import { attachmentMaster } from '../Models/BasicForms/attachmentMaster';
import { taskSubtaskMaster } from '../Models/BasicForms/taskSubtaskMaster';
import { worklogM } from '../Models/BasicForms/worklogM';
import { commentM } from '../Models/BasicForms/commentM';
import { taskTransferM } from '../Models/BasicForms/taskTransferM';
import { typeM } from '../Models/BasicForms/typeM';
import { assigneeMapping } from '../Models/BasicForms/assigneeMapping';
import { PickTask } from '../Models/BasicForms/picktask';
import { Addtasksubtaskmaster } from '../Models/BasicForms/addtasksubtaskmaster';
import { AddTask } from '../Models/BasicForms/addtask';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  // currentMessage = new BehaviorSubject(null);

  clientId = 1;

  // headers for forms all
  httpHeaders = new HttpHeaders();
  options = {
    headers: this.httpHeaders,
  };

  // headers for forms file upload call
  httpHeaders1 = new HttpHeaders();
  options1 = {
    headers: this.httpHeaders1,
  };

  baseUrl = 'https://pms.tecpool.in:3934/';
    // baseUrl = "http://192.168.29.208:2001/";
  // baseUrl = "https://vks6dmd3-9999.inc1.devtunnels.ms/";

 
  // baseUrl = "https://63db-2401-4900-1c9b-30cf-ad25-a8bd-6d18-862c.ngrok-free.app/";

  // APIKEY = '68h3u1OxG6We2UnRD4F3IratYZHQ5hRB'
  // APPLICATION_KEY = 'AfIpESwBr5eHp7w3'

  // live
  //  'apikey': 'dW5tIgokj06f3ENSCaqIxxUJhowrRDNa',
  // 'applicationkey': 'S2bLcsluqAt8o8HI',

  gmUrl = 'https://gm.tecpool.in:8078/';
  // gmUrl = "http://ea90-223-178-218-78.ngrok.io/";

  imgUrl = this.baseUrl + 'api/upload/';
  retriveimgUrl = this.baseUrl + 'static/';

  url = this.baseUrl + 'api/';

  dateforlog =
    new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString();
  emailId = this.cookie.get('emailId');
  userId = Number(this.cookie.get('userId'));
  userName = this.cookie.get('userName');
  roleId = this.cookie.get('roleId');

  socketUrl = 'http://pms.tecpool.in:3934';
  // socketUrl = "http://ea90-223-178-218-78.ngrok.io";

  constructor(
    private cookie: CookieService,
    private message: NzNotificationService,
    private httpClient: HttpClient
  ) {
    if (
      this.cookie.get('deviceId') === '' ||
      this.cookie.get('deviceId') === null
    ) {
      var deviceId = this.randomstring(16);
      this.cookie.set(
        'deviceId',
        deviceId.toString(),
        365,
        '',
        '',
        false,
        'Strict'
      );
    }
    // else if(this.userId == null || this.userName == null || this.roleId == null)
    // {
    //   this.logoutForSessionValues()
    // }

    this.httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      apikey: 'dW5tIgokj06f3ENSCaqIxxUJhowrRDNa',
      applicationkey: 'S2bLcsluqAt8o8HI',
      deviceid: this.cookie.get('deviceId'),
      supportkey: this.cookie.get('supportKey'),
      Token: this.cookie.get('token'),
    });
    this.options = {
      headers: this.httpHeaders,
    };

    // this.angularFireMessaging.messaging.subscribe(
    //   (_messaging) => {
    //     _messaging.onMessage = _messaging.onMessage.bind(_messaging);
    //     _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
    //   }
    // )
  }

  getSecondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);
    if (h == 0) return m + ' m ' + s + ' s ';
    else return h + ' h ' + m + ' m ';
  }

  //generate string as we pass length - LOGIN_FROMS
  randomstring(L) {
    var s = '';
    var randomchar = function () {
      var n = Math.floor(Math.random() * 62);
      if (n < 10) return n; //1-10
      if (n < 36) return String.fromCharCode(n + 55); //A-Z
      return String.fromCharCode(n + 61); //a-z
    };
    while (s.length < L) s += randomchar();
    return s;
  }

  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  generateRandomNumber(n) {
    return (
      Math.floor(Math.random() * (9 * Math.pow(10, n - 1))) +
      Math.pow(10, n - 1)
    );
  }

  logoutForSessionValues() {
    this.cookie.deleteAll();
    window.location.reload();
  }

  //firebase methods - FIREBASE
  receiveMessage() {
    // this.angularFireMessaging.messages.subscribe(
    //   (payload) => {
    //
    //     this.message.info(payload['data']['title'], payload['data']['body'])
    //     this.currentMessage.next(payload);
    //   })
  }

  requestPermission(userId) {
    // this.angularFireMessaging.requestToken.subscribe(
    //   (token) => {
    //     this.cloudID = token
    //     //this.updateToken(userId, token);
    //   },
    //   (err) => {
    //     console.error('Unable to get permission to notify.', err);
    //   }
    // );
  }

  // implement logger - LOGGER
  loggerInit() {
    this.httpHeaders1 = new HttpHeaders({
      'Content-Type': 'application/json',
      apikey: 'dW5tIgokj06f3ENSCaqIxxUJhowrRDNa',
      applicationkey: 'S2bLcsluqAt8o8HI',
      deviceid: this.cookie.get('deviceId'),
    });
    this.options1 = {
      headers: this.httpHeaders1,
    };

    var data = {
      CLIENT_ID: this.clientId,
    };
    return this.httpClient.post(
      this.gmUrl + 'device/init',
      JSON.stringify(data),
      this.options1
    );
  }

  addLog(type, text, userId): Observable<number> {
    this.httpHeaders1 = new HttpHeaders({
      'Content-Type': 'application/json',
      apikey: 'dW5tIgokj06f3ENSCaqIxxUJhowrRDNa',
      applicationkey: 'S2bLcsluqAt8o8HI',
      deviceid: this.cookie.get('deviceId'),
      supportkey: this.cookie.get('supportKey'),
      Token: this.cookie.get('token'),
    });
    this.options1 = {
      headers: this.httpHeaders1,
    };
    var data = {
      LOG_TYPE: type,
      LOG_TEXT: this.dateforlog + ' ' + text,
      USER_ID: userId,
      CLIENT_ID: this.clientId,
    };
    return this.httpClient.post<number>(
      this.gmUrl + 'device/addLog',
      JSON.stringify(data),
      this.options1
    );
  }

  // login method - LOGIN
  login(email: string, password: string) {
    this.httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      apikey: 'dW5tIgokj06f3ENSCaqIxxUJhowrRDNa',
      applicationkey: 'S2bLcsluqAt8o8HI',
      deviceid: this.cookie.get('deviceId'),
      supportkey: this.cookie.get('supportKey'),
      Token: this.cookie.get('token'),
    });

    this.options = {
      headers: this.httpHeaders,
    };

    var data = {
      username: email,
      password: password,
    };

    return this.httpClient.post(
      this.baseUrl + 'user/login',
      JSON.stringify(data),
      this.options
    );
  }

  onUpload(folderName, selectedFile, filename): Observable<any> {
    this.httpHeaders1 = new HttpHeaders({
      Accept: 'application/json',
      apikey: 'dW5tIgokj06f3ENSCaqIxxUJhowrRDNa',
      Token: this.cookie.get('token'),
      supportkey: this.cookie.get('supportKey'),
    });
    this.options1 = {
      headers: this.httpHeaders1,
    };

    const fd = new FormData();
    fd.append('Image', selectedFile, filename);

    return this.httpClient.post(this.imgUrl + folderName, fd, this.options1);
  }

  // upload image with key - UPLOAD_IMAGE
  onUploadNewMethod(selectedFile, ext, fKey) {
    this.httpHeaders1 = new HttpHeaders({
      //'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
      f_key: fKey,
      f_ext: ext,
      supportkey: this.cookie.get('supportKey'),
      apikey: 'dW5tIgokj06f3ENSCaqIxxUJhowrRDNa',
      applicationkey: 'S2bLcsluqAt8o8HI',
      Token: this.cookie.get('token'),
    });
    this.options1 = {
      headers: this.httpHeaders1,
    };
    const fd = new FormData();
    fd.append('F_DATA', selectedFile);
    fd.append('F_EXT', ext);
    fd.append('F_KEY', fKey);
    return this.httpClient.post(this.gmUrl + 'file/upload', fd, this.options1);
  }

  onUploadNewMethodBulk(selectedFile) {
    this.httpHeaders1 = new HttpHeaders({
      //'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
      supportkey: this.cookie.get('supportKey'),
      apikey: 'dW5tIgokj06f3ENSCaqIxxUJhowrRDNa',
      applicationkey: 'S2bLcsluqAt8o8HI',
      Token: this.cookie.get('token'),
    });
    this.options1 = {
      headers: this.httpHeaders1,
    };

    const fd = new FormData();
    for (let file of selectedFile) {
      let name =
        file.f_key + '_' + file.url_key + '.' + file.name.split('.').pop();
      fd.append('F_DATA', file, name);
    }
    return this.httpClient.post(
      this.gmUrl + 'File/uploadBulk',
      fd,
      this.options1
    );
  }

  //retrive file - GETTING_FILE
  getFile(lkey) {
    this.httpHeaders1 = new HttpHeaders({
      Accept: 'application/pdf',
      supportkey: this.cookie.get('supportKey'),
      apikey: 'dW5tIgokj06f3ENSCaqIxxUJhowrRDNa',
      applicationkey: 'S2bLcsluqAt8o8HI',
      Token: this.cookie.get('token'),
    });
    this.options1 = {
      headers: this.httpHeaders1,
    };

    var data = {
      L_KEY: lkey,
    };
    return this.httpClient.post<any>(
      this.gmUrl + 'file/getFile',
      data,
      this.options1
    );
  }

  //get all Form For login menu
  getForms(roleId: number) {
    var data = {
      ROLE_ID: roleId,
    };
    return this.httpClient.post<Roledetails>(
      this.url + 'user/getForms',
      JSON.stringify(data),
      this.options
    );
  }

  getCheckAccessOfForm(roleId: number, link: string) {
    var data = {
      ROLE_ID: roleId,
      LINK: link,
    };
    return this.httpClient.post<Roledetails>(
      this.url + 'roleDetails/checkAccess',
      JSON.stringify(data),
      this.options
    );
  }

  //methods for form related opearation  - FORM
  getAllForms(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<Form[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<Form[]>(
      this.url + 'form/get',
      JSON.stringify(data),
      this.options
    );
  }

  createForm(form: Form): Observable<number> {
    form.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'form/create/',
      JSON.stringify(form),
      this.options
    );
  }

  updateForm(form: Form): Observable<number> {
    form.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'form/update/',
      JSON.stringify(form),
      this.options
    );
  }

  //methods for role related opearation  - ROLE
  getAllRoles(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<Role[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<Role[]>(
      this.url + 'role/get',
      JSON.stringify(data),
      this.options
    );
  }

  createRole(application: Role): Observable<number> {
    application.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'role/create/',
      JSON.stringify(application),
      this.options
    );
  }

  updateRole(application: Role): Observable<number> {
    application.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'role/update/',
      JSON.stringify(application),
      this.options
    );
  }

  //get all form assigned - ROLE_DETAILS
  getRoleDetails(roleId: number) {
    var data = {
      ROLE_ID: roleId,
    };

    return this.httpClient.post<Roledetails[]>(
      this.url + 'roleDetails/getData',
      JSON.stringify(data),
      this.options
    );
  }

  // assign all method forms - ROLE_DETAILS
  addRoleDetails(roleId: number, data1: string[]): Observable<number> {
    var data = {
      ROLE_ID: roleId,
      data: data1,
    };
    return this.httpClient.post<number>(
      this.url + 'roleDetails/addBulk',
      data,
      this.options
    );
  }

  // Get Roadmap Data
  getKanbanView(flag: number, projectId: number) {
    var data = {
      FLAG: flag,
      PROJECT_ID: projectId,
    };

    return this.httpClient.post<[]>(
      this.url + 'project/getKanbanData',
      JSON.stringify(data),
      this.options
    );
  }

  // Get Roadmap Data by Status
  getKanbanByStatusView(flag: number, projectId: number, status: string) {
    var data = {
      FLAG: flag,
      PROJECT_ID: projectId,
      STATUS: status,
    };

    return this.httpClient.post<[]>(
      this.url + 'project/getKanbanData',
      JSON.stringify(data),
      this.options
    );
  }

  // Get Mapping Wise Roadmap Data by Status
  getMappingWiseKanbanView(
    flag: number,
    projectId: number,
    assigneeID: number
  ) {
    var data = {
      FLAG: flag,
      PROJECT_ID: projectId,
      ASSIGNEE_IDS: assigneeID,
    };

    return this.httpClient.post<[]>(
      this.url + 'project/getKanbanData',
      JSON.stringify(data),
      this.options
    );
  }

  // Get Mapping Wise, Status Wise Roadmap Data by Status
  getMappingWiseStatusWiseKanbanView(
    flag: number,
    projectId: number,
    assigneeID: number,
    status: string
  ) {
    var data = {
      FLAG: flag,
      PROJECT_ID: projectId,
      ASSIGNEE_IDS: assigneeID,
      ASSIGNEE_STATUS: status,
    };

    return this.httpClient.post<[]>(
      this.url + 'project/getKanbanData',
      JSON.stringify(data),
      this.options
    );
  }

  // Project Mapping : Get Data
  getProjectDetails(projectId: number, taskCategoryId: number) {
    var data = {
      PROJECT_ID: projectId,
      TASK_CATEGORY_ID: taskCategoryId,
    };

    return this.httpClient.post<[]>(
      this.url + 'projectTeamMapping/getData',
      JSON.stringify(data),
      this.options
    );
  }

  // Project Mapping : Add Bulk
  addProjectMappingDetails(
    projectId: number,
    data1: string[]
  ): Observable<number> {
    var data = {
      PROJECT_ID: projectId,
      data: data1,
    };

    return this.httpClient.post<number>(
      this.url + 'projectTeamMapping/addBulk',
      data,
      this.options
    );
  }

  // Module Mapping : Get Data
  getModuleDetails(moduleId: number, taskCategoryId: number) {
    var data = {
      MODULE_ID: moduleId,
      TASK_CATEGORY_ID: taskCategoryId,
    };

    return this.httpClient.post<[]>(
      this.url + 'moduleTeamMapping/getData',
      JSON.stringify(data),
      this.options
    );
  }

  // Module Mapping : Add Bulk
  addModuleMappingDetails(
    moduleId: number,
    data1: string[]
  ): Observable<number> {
    var data = {
      MODULE_ID: moduleId,
      data: data1,
    };

    return this.httpClient.post<number>(
      this.url + 'moduleTeamMapping/addBulk',
      data,
      this.options
    );
  }

  // Feature Mapping : Get Data
  getFeatureDetails(featureId: number, taskCategoryId: number) {
    var data = {
      FEATURE_ID: featureId,
      TASK_CATEGORY_ID: taskCategoryId,
    };

    return this.httpClient.post<[]>(
      this.url + 'featureTeamMapping/getData',
      JSON.stringify(data),
      this.options
    );
  }

  // Feature Mapping : Add Bulk
  addFeatureMappingDetails(
    featureId: Number,
    data1: string[]
  ): Observable<number> {
    var data = {
      FEATURE_ID: featureId,
      data: data1,
    };

    return this.httpClient.post<number>(
      this.url + 'featureTeamMapping/addBulk',
      data,
      this.options
    );
  }

  // Task, Subtask Mapping : Get Data
  getTaskSubtaskDetails(taskId: number, taskCategoryId: number) {
    var data = {
      TASK_ID: taskId,
      TASK_CATEGORY_ID: taskCategoryId,
    };

    return this.httpClient.post<[]>(
      this.url + 'taskTeamMapping/getData',
      JSON.stringify(data),
      this.options
    );
  }

  // Task, Subtask Mapping : Add Bulk
  addTaskSubtaskMappingDetails(
    taskId: number,
    data1: string[]
  ): Observable<number> {
    var data = {
      TASK_ID: taskId,
      data: data1,
    };

    return this.httpClient.post<number>(
      this.url + 'taskTeamMapping/addBulk',
      data,
      this.options
    );
  }

  //method for user replated opearation - USER
  getAllUsers(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<User[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<User[]>(
      this.url + 'user/get',
      JSON.stringify(data),
      this.options
    );
  }

  createUser(user: User): Observable<number> {
    user.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'user/create/',
      JSON.stringify(user),
      this.options
    );
  }

  updateUser(user: User): Observable<number> {
    user.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'user/update/',
      JSON.stringify(user),
      this.options
    );
  }

  // Client Master
  getAllClients(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<clientMaster[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<clientMaster[]>(
      this.url + 'client/get',
      JSON.stringify(data),
      this.options
    );
  }

  createClient(client: clientMaster): Observable<number> {
    client.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'client/create',
      JSON.stringify(client),
      this.options
    );
  }

  updateClient(client: clientMaster): Observable<number> {
    client.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'client/update',
      JSON.stringify(client),
      this.options
    );
  }

  // Project Master
  getAllProjects(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<project[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<project[]>(
      this.url + 'project/get',
      JSON.stringify(data),
      this.options
    );
  }

  getAllMappedProjects(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<project[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<project[]>(
      this.url + 'projectteammapping/get',
      JSON.stringify(data),
      this.options
    );
  }

  createProject(project: project): Observable<number> {
    project.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'project/create',
      JSON.stringify(project),
      this.options
    );
  }

  updateProject(project: project): Observable<number> {
    project.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'project/update',
      JSON.stringify(project),
      this.options
    );
  }

  // Module Master
  getAllModules(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<moduleMaster[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<moduleMaster[]>(
      this.url + 'module/get',
      JSON.stringify(data),
      this.options
    );
  }

  createModule(module: moduleMaster): Observable<number> {
    module.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'module/create',
      JSON.stringify(module),
      this.options
    );
  }

  updateModule(module: moduleMaster): Observable<number> {
    module.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'module/update',
      JSON.stringify(module),
      this.options
    );
  }

  // Feature Master
  getAllFeatures(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<featureMaster[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<featureMaster[]>(
      this.url + 'feature/get',
      JSON.stringify(data),
      this.options
    );
  }

  createFeature(feature: featureMaster): Observable<number> {
    feature.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'feature/create',
      JSON.stringify(feature),
      this.options
    );
  }

  updateFeature(feature: featureMaster): Observable<number> {
    feature.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'feature/update',
      JSON.stringify(feature),
      this.options
    );
  }

  // Category Master
  getAllCategories(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<categoryMaster[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<categoryMaster[]>(
      this.url + 'taskCategory/get',
      JSON.stringify(data),
      this.options
    );
  }

  createCategory(category: categoryMaster): Observable<number> {
    category.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'taskCategory/create',
      JSON.stringify(category),
      this.options
    );
  }

  updateCategory(category: categoryMaster): Observable<number> {
    category.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'taskCategory/update',
      JSON.stringify(category),
      this.options
    );
  }

  // Task Subtask Master
  getAllTaskSubtask(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<taskSubtaskMaster[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<taskSubtaskMaster[]>(
      this.url + 'task/get',
      JSON.stringify(data),
      this.options
    );
  }

  createTaskSubtask(taskSubtask: taskSubtaskMaster): Observable<number> {
    taskSubtask.CLIENT_ID = this.clientId;
    taskSubtask.USER_ID = this.cookie.get('userId');
    return this.httpClient.post<number>(
      this.url + 'task/create',
      JSON.stringify(taskSubtask),
      this.options
    );
  }

  updateTaskSubtask(taskSubtask: taskSubtaskMaster): Observable<number> {
    taskSubtask.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'task/update',
      JSON.stringify(taskSubtask),
      this.options
    );
  }

  // Attachment Master
  getAllAttachments(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<attachmentMaster[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<attachmentMaster[]>(
      this.url + 'attachments/get',
      JSON.stringify(data),
      this.options
    );
  }

  createAttachment(attachment: attachmentMaster): Observable<number> {
    attachment.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'attachments/create',
      JSON.stringify(attachment),
      this.options
    );
  }

  updateAttachment(attachment: attachmentMaster): Observable<number> {
    attachment.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'attachments/update',
      JSON.stringify(attachment),
      this.options
    );
  }

  // Worklog Master
  getAllWorklogs(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<worklogM[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<worklogM[]>(
      this.url + 'workLogs/get',
      JSON.stringify(data),
      this.options
    );
  }

  createWorklog(worklog: worklogM): Observable<number> {
    worklog.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'workLogs/create',
      JSON.stringify(worklog),
      this.options
    );
  }
  createWorklog1(worklog: worklogM): Observable<number> {
    worklog.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'workLogs/createWorklog',
      JSON.stringify(worklog),
      this.options
    );
  }

  updateWorklog(worklog: worklogM): Observable<number> {
    worklog.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'workLogs/update',
      JSON.stringify(worklog),
      this.options
    );
  }

  deleteWorklog(worklogID: number): Observable<number> {
    var data = {
      ID: worklogID,
    };

    return this.httpClient.put<number>(
      this.url + 'workLogs/delete',
      data,
      this.options
    );
  }

  deletepickedTask(worklogID: number): Observable<number> {
    var data = {
      ID: worklogID,
    };

    return this.httpClient.put<number>(
      this.url + 'dailyTaskMaster/delete',
      data,
      this.options
    );
  }
  // Comment Master
  getComments(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<commentM[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<commentM[]>(
      this.url + 'comments/get',
      JSON.stringify(data),
      this.options
    );
  }

  createComment(comment: commentM): Observable<number> {
    comment.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'comments/create',
      JSON.stringify(comment),
      this.options
    );
  }

  updateComment(comment: commentM): Observable<number> {
    comment.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'comments/update',
      JSON.stringify(comment),
      this.options
    );
  }

  // Task Transfer History
  getAllTaskTransferHistory(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<taskTransferM[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<taskTransferM[]>(
      this.url + 'taskTransferHistory/get',
      JSON.stringify(data),
      this.options
    );
  }

  createTaskTransferHistory(
    taskTransferData: taskTransferM
  ): Observable<number> {
    taskTransferData.CLIENT_ID = this.clientId;

    return this.httpClient.post<number>(
      this.url + 'taskTransferHistory/create',
      taskTransferData,
      this.options
    );
  }

  updateTaskTransferHistory(
    taskTransferData: taskTransferM
  ): Observable<number> {
    taskTransferData.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'taskTransferHistory/update',
      JSON.stringify(taskTransferData),
      this.options
    );
  }

  // Type Master
  getAllType(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<typeM[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<typeM[]>(
      this.url + 'type/get',
      JSON.stringify(data),
      this.options
    );
  }

  createType(typeData: typeM): Observable<number> {
    typeData.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'type/create',
      JSON.stringify(typeData),
      this.options
    );
  }

  updateType(typeData: typeM): Observable<number> {
    typeData.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'type/update',
      JSON.stringify(typeData),
      this.options
    );
  }

  // Get Assignees
  getAllAssignees(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<User[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<User[]>(
      this.url + 'assigneeMapping/get',
      JSON.stringify(data),
      this.options
    );
  }

  updateAssignees(typeData: assigneeMapping): Observable<number> {
    typeData.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'assigneeMapping/update',
      JSON.stringify(typeData),
      this.options
    );
  }

  // Employee Wise Working Hours
  getEmplyeeWiseWorkingHours(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    userName: string,
    userID: string,
    projectID: string,
    fromDate: string,
    toDate: string
  ): Observable<[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      NAME: userName,
      USER_IDS: userID,
      PROJECT_IDS: projectID,
      FROM_DATE: fromDate,
      TO_DATE: toDate,
    };
    return this.httpClient.post<[]>(
      this.url + 'reports/getEmpDateWiseWorkingHours',
      JSON.stringify(data),
      this.options
    );
  }

  // Project Wise Employee's Working Hours
  getProjectWiseEmployeeWorkingHours(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    userName: string,
    userID: string,
    projectID: string,
    fromDate: string,
    toDate: string
  ): Observable<[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      NAME: userName,
      USER_IDS: userID,
      PROJECT_IDS: projectID,
      FROM_DATE: fromDate,
      TO_DATE: toDate,
    };
    return this.httpClient.post<[]>(
      this.url + 'reports/getEmpProjectWiseWorkingHours',
      JSON.stringify(data),
      this.options
    );
  }

  getallemployeedetailsoftasks(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    userName: string,
    userID: string,
    projectID: string,
    fromDate: string,
    toDate: string
  ): Observable<[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      EMPLOYEE_NAME: userName,
      USER_IDS: userID,
      PROJECT_IDS: projectID,
      FROM_DATE: fromDate,
      TO_DATE: toDate,
    };
    return this.httpClient.post<[]>(
      this.url + 'giantViewReport/getGaintViewReport',
      JSON.stringify(data),
      this.options
    );
  }
  getallemployeedetailsoftasks1(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<[]>(
      this.url + 'giantViewReport/getGaintViewReport',
      JSON.stringify(data),
      this.options
    );
  }

  // Employee Wise Project's Working Hours
  getEmployeeWiseProjectWorkingHours(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    userName: string,
    userID: string,
    projectID: string,
    fromDate: string,
    toDate: string
  ): Observable<[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      NAME: userName,
      USER_IDS: userID,
      PROJECT_IDS: projectID,
      FROM_DATE: fromDate,
      TO_DATE: toDate,
    };
    return this.httpClient.post<[]>(
      this.url + 'reports/getProjectWiseSummary',
      JSON.stringify(data),
      this.options
    );
  }

  // Project Wise Working Hours
  getProjectWiseWorkingHours(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    projectID: string,
    fromDate: string,
    toDate: string
  ): Observable<[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      IDS: projectID,
      FROM_DATE: fromDate,
      TO_DATE: toDate,
    };
    return this.httpClient.post<[]>(
      this.url + 'reports/getProjectWiseWorkingHours',
      JSON.stringify(data),
      this.options
    );
  }

  // Project Wise Details
  getProjectWiseDetails(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string,
    projectID: number,
    userName: string
  ): Observable<[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
      PROJECT_ID: projectID,
      LIKE_STRING: userName,
    };
    return this.httpClient.post<[]>(
      this.url + 'reports/getProjectWiseEmpWorkingHours',
      JSON.stringify(data),
      this.options
    );
  }

  // Project Wise Summary
  getProjectWiseSummary(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string,
    projectID: number,
    userName: string
  ): Observable<[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
      PROJECT_ID: projectID,
      LIKE_STRING: userName,
    };
    return this.httpClient.post<[]>(
      this.url + 'reports/getProjectDetailedReport',
      JSON.stringify(data),
      this.options
    );
  }

  // User Wise Subtask Details Summary
  getUserWiseProjectSummary(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    userName: string,
    userID: string,
    projectID: string,
    fromDate: string,
    toDate: string
  ): Observable<[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      LIKE_STRING: userName,
      USER_IDS: userID,
      PROJECT_IDS: projectID,
      FROM_DATE: fromDate,
      TO_DATE: toDate,
    };
    return this.httpClient.post<[]>(
      this.url + 'reports/getUserWiseDetailedReport',
      JSON.stringify(data),
      this.options
    );
  }

  // User Wise Details Summary
  getUserWiseDetailsSummary(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    userName: string,
    userID: string,
    projectID: string,
    fromDate: string,
    toDate: string
  ): Observable<[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      LIKE_STRING: userName,
      USER_IDS: userID,
      PROJECT_IDS: projectID,
      FROM_DATE: fromDate,
      TO_DATE: toDate,
    };
    return this.httpClient.post<[]>(
      this.url + 'reports/getUserSubtaskDetails',
      JSON.stringify(data),
      this.options
    );
  }

  // User Wise Efficiency
  getUserEfficiencySummary(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string,
    userName: string,
    userID: string,
    fromDate: string,
    toDate: string
  ): Observable<[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
      NAME_LIKE: userName,
      USER_ID: userID,
      FROM_DATE: fromDate,
      TO_DATE: toDate,
    };
    return this.httpClient.post<[]>(
      this.url + 'reports/getEfficiency',
      JSON.stringify(data),
      this.options
    );
  }

  //method for user replated opearation - USER
  getAllMappedUsers(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<User[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<User[]>(
      this.url + 'projectTeamMapping/get',
      JSON.stringify(data),
      this.options
    );
  }

  // Get User Initial
  createBadge(nameForBadge: string) {
    var initial = '';
    var nameArr = nameForBadge.split(' ');

    if (nameArr.length == 2) {
      var firstNameInitial = nameArr[0].charAt(0);
      var lastNameInitial = nameArr[1].charAt(0);
      initial = firstNameInitial + lastNameInitial;
    } else {
      var firstNameInitial = nameArr[0].charAt(0);
      initial = firstNameInitial;
    }

    return initial.toUpperCase();
  }

  // Conversion into HMS
  convertIntoHMS(value) {
    const sec = parseInt(value, 10);

    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - hours * 3600) / 60);
    let seconds = sec - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = 0 + hours;
    }
    if (minutes < 10) {
      minutes = 0 + minutes;
    }
    if (seconds < 10) {
      seconds = 0 + seconds;
    }

    var totalWorklogTime = hours + 'h ' + minutes + 'm ' + seconds + 's';
    return totalWorklogTime;
  }

  getDairyOutletPincodeMapping(Id: number, filter: string) {
    var data = {
      DAIRY_OUTLET_MASTER_ID: Id,
      filter: filter,
    };
    return this.httpClient.post<string[]>(
      this.url + 'dairyOutletPincodeMapping/getData',
      JSON.stringify(data),
      this.options
    );
  }

  addDairyOutletPincodeMapping(
    Id: number,
    data1: string[]
  ): Observable<number> {
    var data = {
      DAIRY_OUTLET_MASTER_ID: Id,
      data: data1,
    };
    return this.httpClient.post<number>(
      this.url + 'dairyOutletPincodeMapping/addBulk',
      data,
      this.options
    );
  }

  getGavaliPincodeMapping(
    Id: number,
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ) {
    var data = {
      GAVALI_MASTER_ID: Id,
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<string[]>(
      this.url + 'gavaliPincodeMapping/getData',
      JSON.stringify(data),
      this.options
    );
  }

  addGavaliOutletPincodeMapping(
    Id: number,
    data1: string[]
  ): Observable<number> {
    var data = {
      GAVALI_MASTER_ID: Id,
      data: data1,
    };
    return this.httpClient.post<number>(
      this.url + 'gavaliPincodeMapping/addBulk',
      data,
      this.options
    );
  }

  getOnemanPincodeMapping(
    Id: number,
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ) {
    var data = {
      ONE_MAN_MASTER_ID: Id,
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };

    return this.httpClient.post<string[]>(
      this.url + 'oneManPincodeMapping/getData',
      JSON.stringify(data),
      this.options
    );
  }

  addOnemanPincodeMapping(Id: number, data1: string[]): Observable<number> {
    var data = {
      ONE_MAN_MASTER_ID: Id,
      data: data1,
    };
    return this.httpClient.post<number>(
      this.url + 'oneManPincodeMapping/addBulk',
      data,
      this.options
    );
  }

  getAllNotification(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<Notification[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<Notification[]>(
      this.url + 'notification/get',
      JSON.stringify(data),
      this.options
    );
  }

  createNotification(notification): Observable<number> {
    notification.VISIBILITY = notification.VISIBILITY ? 1 : 0;
    notification.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'notification/create/',
      JSON.stringify(notification),
      this.options
    );
  }

  updateNotification(notification): Observable<number> {
    notification.VISIBILITY = notification.VISIBILITY ? 1 : 0;
    notification.CLIENT_ID = this.clientId;

    return this.httpClient.put<number>(
      this.url + 'notification/update/',
      JSON.stringify(notification),
      this.options
    );
  }

  getAllDairyOutletPincodeMappings(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<string[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<string[]>(
      this.url + 'dairyOutletPincodeMapping/get',
      JSON.stringify(data),
      this.options
    );
  }

  getAllGavaliPincodeMappings(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<string[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<string[]>(
      this.url + 'gavaliPincodeMapping/get',
      JSON.stringify(data),
      this.options
    );
  }

  getAllOnemanpincodemappings(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<string[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<string[]>(
      this.url + 'oneManPincodeMapping/get',
      JSON.stringify(data),
      this.options
    );
  }

  getAllLiveVideoBatchMapping(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<string[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<string[]>(
      this.url + 'liveVideoBatchMapping/get',
      JSON.stringify(data),
      this.options
    );
  }

  addFarmerBatchMapping(Id: number, data1: string[]): Observable<number> {
    var data = {
      BATCH_ID: Id,
      data: data1,
    };
    return this.httpClient.post<number>(
      this.url + 'farmerBatchMapping/addBulk',
      data,
      this.options
    );
  }

  getAllDashboarddata(month: number, year: number): Observable<string[]> {
    var data = {
      MONTH: month,
      YEAR: year,
    };
    return this.httpClient.post<string[]>(
      this.url + 'user/getDashboardData',
      JSON.stringify(data),
      this.options
    );
  }

  getLivePoleMapping(liveId: number) {
    var data = {
      LIVE_ID: liveId,
    };
    return this.httpClient.post<string[]>(
      this.url + 'livePoleMapping/getData',
      JSON.stringify(data),
      this.options
    );
  }

  addLivePoleMapping(liveId: number, data1: string[]): Observable<number> {
    var data = {
      LIVE_ID: liveId,
      data: data1,
    };
    return this.httpClient.post<number>(
      this.url + 'livePoleMapping/addBulk',
      data,
      this.options
    );
  }

  getAllLiveVideoUserReponses(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<string[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<string[]>(
      this.url + 'poleUserResponses/get',
      JSON.stringify(data),
      this.options
    );
  }

  getAllLiveComments(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<string[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<string[]>(
      this.url + 'liveVideoComments/get',
      JSON.stringify(data),
      this.options
    );
  }

  getAllLivevideonotificationMapping(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<string[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<string[]>(
      this.url + 'liveVideoNotificationSetting/get',
      JSON.stringify(data),
      this.options
    );
  }

  updateLiveComments(liveVideos): Observable<number> {
    liveVideos.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'liveVideoComments/update/',
      JSON.stringify(liveVideos),
      this.options
    );
  }

  updateLiveUsers(liveVideos): Observable<number> {
    liveVideos.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'liveVideoUsers/update/',
      JSON.stringify(liveVideos),
      this.options
    );
  }

  getAllHomePageInfo(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<Homepage[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<Homepage[]>(
      this.url + 'homepageInformation/get',
      JSON.stringify(data),
      this.options
    );
  }

  createHomePageInfo(batch: Homepage): Observable<number> {
    batch.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'homepageInformation/create/',
      JSON.stringify(batch),
      this.options
    );
  }

  updateHomePageInfo(batch: Homepage): Observable<number> {
    batch.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'homepageInformation/update/',
      JSON.stringify(batch),
      this.options
    );
  }

  getLiveFFFMapping(liveId: number) {
    var data = {
      LIVE_ID: liveId,
    };
    return this.httpClient.post<string[]>(
      this.url + 'fffLiveMapping/getData',
      JSON.stringify(data),
      this.options
    );
  }

  addLiveFFFMapping(liveId: number, data1: string[]): Observable<number> {
    var data = {
      LIVE_ID: liveId,
      data: data1,
    };

    return this.httpClient.post<number>(
      this.url + 'fffLiveMapping/addBulk',
      data,
      this.options
    );
  }

  getAllLiveFFFMapping(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<Homepage[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<Homepage[]>(
      this.url + 'fffLiveMapping/get',
      JSON.stringify(data),
      this.options
    );
  }

  getAllLiveVideofffUserReponses(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<string[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<string[]>(
      this.url + 'fffUserResponses/get',
      JSON.stringify(data),
      this.options
    );
  }

  addFarmerCertificateMapping(
    certificateId: string,
    courseId: number,
    data1: string[]
  ): Observable<number> {
    var data = {
      CERTIFICATE_ID: certificateId,
      COURSE_ID: courseId,
      CLIENT_ID: this.clientId,
      data: data1,
    };
    return this.httpClient.post<number>(
      this.url + 'farmerCertificateMapping/addBulk',
      data,
      this.options
    );
  }
  getAllDailymaster(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<project[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<project[]>(
      this.url + 'dailyTaskMaster/get',
      JSON.stringify(data),
      this.options
    );
  }

  createDailymaster(project: any): Observable<any> {
    project.CLIENT_ID = this.clientId;
    return this.httpClient.post<any>(
      this.url + 'dailyTaskMaster/create',
      JSON.stringify(project),
      this.options
    );
  }

  getAlltask(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<AddTask[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<AddTask[]>(
      this.url + 'dailyTaskDetail/get',
      JSON.stringify(data),
      this.options
    );
  }

  createtask(batch: AddTask): Observable<number> {
    batch.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'dailyTaskDetail/create/',
      JSON.stringify(batch),
      this.options
    );
  }

  updatetask(batch: AddTask): Observable<number> {
    batch.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'dailyTaskDetail/update/',
      JSON.stringify(batch),
      this.options
    );
  }

  Picktask(batch: PickTask): Observable<number> {
    batch.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'dailyTaskMaster/create/',
      JSON.stringify(batch),
      this.options
    );
  }

  getAllPickedtask(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string
  ): Observable<PickTask[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
    };
    return this.httpClient.post<PickTask[]>(
      this.url + 'dailyTaskMaster/get',
      JSON.stringify(data),
      this.options
    );
  }

  createSubTask(batch: taskSubtaskMaster): Observable<number> {
    batch.CLIENT_ID = this.clientId;
    batch.USER_ID = this.cookie.get('userId');
    return this.httpClient.post<number>(
      this.url + 'task/create',
      JSON.stringify(batch),
      this.options
    );
  }

  daily_sub_task_master(batch: Addtasksubtaskmaster): Observable<number> {
    batch.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(
      this.url + 'dailySubTaskMaster/create',
      JSON.stringify(batch),
      this.options
    );
  }
  // daily_sub_task_worklog_master(batch: Adworklogmaster): Observable<number> {
  //   batch.CLIENT_ID = this.clientId;
  //   return this.httpClient.post<number>(this.url + "dailySubTaskMaster/create", JSON.stringify(batch), this.options);
  // }
  getAllTaskSubtask1(
    pageIndex: number,
    pageSize: number,
    sortKey: string,
    sortValue: string,
    filter: string,
    date
  ): Observable<taskSubtaskMaster[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter,
      DATE: date,
    };
    return this.httpClient.post<taskSubtaskMaster[]>(
      this.url + 'task/getTask',
      JSON.stringify(data),
      this.options
    );
  }
  updateTaskSubtasknew(data): Observable<number> {
    data.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(
      this.url + 'assigneeMapping/updateAssignees',
      JSON.stringify(data),
      this.options
    );
  }

  // New added

  checkExistsBilling(user: any): Observable<any> {
    // (user.CLIENT_ID = this.clientId);

    return this.httpClient.post<any>(
      this.url + 'monthlyBilling/checkExists',

      JSON.stringify(user),

      this.options
    );
  }

  MapChangedSequence(user: any): Observable<any> {
    // (user.CLIENT_ID = this.clientId);

    return this.httpClient.post<any>(
      this.url + 'monthlyBilling/pushData',

      JSON.stringify(user),

      this.options
    );
  }

  // User Wise Details Summary

  getMonthlyBilling(year: any, month: any): Observable<[]> {
    var data = {
      year: year,

      month: month,
    };

    return this.httpClient.post<[]>(
      this.url + 'monthlyBilling/getSummary',
      JSON.stringify(data),
      this.options
    );
  }

  updateMonthData(user: any): Observable<any> {
    // (user.CLIENT_ID = this.clientId);

    return this.httpClient.post<any>(
      this.url + 'monthlyBilling/updateMonthData',

      JSON.stringify(user),

      this.options
    );
  }

  updateSequenceData(user: any): Observable<any> {
    // (user.CLIENT_ID = this.clientId);

    return this.httpClient.post<any>(
      this.url + 'project/updateSeqNo',

      JSON.stringify(user),

      this.options
    );
  }
  updateUserData(user: any): Observable<any> {
    // (user.CLIENT_ID = this.clientId);

    return this.httpClient.post<any>(
      this.url + 'userCtc/addBulk',

      JSON.stringify(user),

      this.options
    );
  }

  EmployeeBilling(selectyear: any): Observable<[]> {
    var data = {
      year: selectyear,
    };

    return this.httpClient.post<[]>(
      this.url + 'monthlyBilling/getYearSummary',
      JSON.stringify(data),
      this.options
    );
  }

  getemployeeUpdatedSeqProcjet(startDate): Observable<any[]> {
    var data = {
      startDate: startDate,

      // projectId:projectId,

      // userId:userId
    };

    return this.httpClient.post<any[]>(
      this.url + 'monthlyBilling/getProjects',
      JSON.stringify(data),
      this.options
    );
  }

  getemployeePushedReport(startDate, endDate): Observable<any[]> {
    var data = {
      startDate: startDate,

      endDate: endDate,

      // projectId:projectId,

      // userId:userId
    };

    return this.httpClient.post<any[]>(
      this.url + 'monthlyBilling/getFixed',
      JSON.stringify(data),
      this.options
    );
  }

  updateeditedMonthData(user: any): Observable<any> {
    // (user.CLIENT_ID = this.clientId);

    return this.httpClient.post<any>(
      this.url + 'monthlyBilling/updateData',

      JSON.stringify(user),

      this.options
    );
  }

  finanizeMonthData(user: any): Observable<any> {
    // (user.CLIENT_ID = this.clientId);

    return this.httpClient.post<any>(
      this.url + 'monthlyBilling/finalize',

      JSON.stringify(user),

      this.options
    );
  }

  getEvaluation(
    userID: string,
    projectID: string,
    fromDate: string,
    toDate: string
  ): Observable<[]> {
    var data = {
      userId: userID,

      projectId: projectID,

      startDate: fromDate,

      endDate: toDate,
    };

    return this.httpClient.post<[]>(
      this.url + 'workLogReports/getEmployeeDailyPMS',
      JSON.stringify(data),
      this.options
    );
  }

  getusers(
    pageIndex: number,

    pageSize: number,

    sortKey: string,

    sortValue: string,

    filter: string
  ): Observable<any> {
    var data = {
      pageIndex: pageIndex,

      pageSize: pageSize,

      sortKey: sortKey,

      sortValue: sortValue,

      filter: filter,
    };

    return this.httpClient.post<any>(
      this.baseUrl + 'api/user/get',

      JSON.stringify(data),

      this.options
    );
  }
      getusersRoleMapping(
    pageIndex: number,

    pageSize: number,

    sortKey: string,

    sortValue: string,

    filter: string
  ): Observable<any> {
    var data = {
      pageIndex: pageIndex,

      pageSize: pageSize,

      sortKey: sortKey,

      sortValue: sortValue,

      filter: filter,
    };

    return this.httpClient.post<any>(
      this.baseUrl + 'api/userRoleMapping/get',

      JSON.stringify(data),

      this.options
    );
  }

  GETmonthlyBilling(
    startDate: any,
    endDate: any,
    projectId: string,
    userId: string
  ): Observable<[]> {
    var data = {
      startDate: startDate, // Pass startDate
      endDate: endDate, // Pass endDate
      projectId: projectId, // Pass projectId as a string of comma-separated values
      userId: userId, // Pass userId as a string of comma-separated values
    };

    return this.httpClient.post<[]>(
      this.url + 'monthlyBilling/getPreview',
      JSON.stringify(data),
      this.options
    );
  }
  GETmonthlPreviewReport(
    startDate: any,
    endDate: any,
    projectId: string,
    userId: string
  ): Observable<[]> {
    var data = {
      startDate: startDate, // Pass startDate
      endDate: endDate, // Pass endDate
      projectId: projectId, // Pass projectId as a string of comma-separated values
      userId: userId, // Pass userId as a string of comma-separated values
    };

    return this.httpClient.post<[]>(
      this.url + 'monthlyBilling/getPreviewAuthority',
      JSON.stringify(data),
      this.options
    );
  }


  getMappedQualifications(id: any): Observable<any> {
    console.log(id);
    // return this.httpClient.get<any>(
    //   `${this.url}doctor/${id}/getQualification`,
    //   {
    //     observe: 'response',
    //   }
    // );
    var data = {
      filter: 'AND USER_ID =' +id, // Pass startDate

    }
    return this.httpClient.post<[]>(
      this.url + 'user/getAuthority',
      JSON.stringify(data),
      this.options
    );
  }
  getMappedPreviewReport(id: any): Observable<any> {
    console.log(id);
    // return this.httpClient.get<any>(
    //   `${this.url}doctor/${id}/getQualification`,
    //   {
    //     observe: 'response',
    //   }
    // );
    var data = {
      filter: 'AND AUTHORITY_ID =' +id, // Pass startDate

    }
    return this.httpClient.post<[]>(
      this.url + 'user/getAuthority',
      JSON.stringify(data),
      this.options
    );
  }
  mapQualificationscall(data: any): Observable<any> {
    return this.httpClient.post<any>(
      this.url + 'user/mapAuthority',
      JSON.stringify(data),
      this.options
    );
  }
}
